/**
 * Store para cuentas x pagar para la revision 2
 * SOLO deben declarase aquí lo relacionado con los REEMBOLSOS INTERNOS
 *
 * para acceder a las actions de este store hay que usar el siguiente formato:
 * ...mapActions({
 *  ...
 *  action_alias: 'cuentasxpagar/v2/reembolso/<action_name>',
 *  ...
 * })
 *
 */
import axios from '@axios'
import { defineStore } from '@core/utils/vuex'


export default defineStore({
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {},
})
